import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {PaZone} from '@catmodules/models/pa-zone/types';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class PaZoneService extends RestHttpService<PaZone> {

  constructor(service: Restangular) {
    super('pa-zones', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/pa-zone/services/pa-zone.service.ts